import Vue from 'vue'

const state = () => ({
    data: [],
})

const getters = {
    getFichaById: (state) => (id) => {
        return state.data.find(f => f.id == id)
    }
}

const actions = {
}

const mutations = {
    addFicha (state, data) {
        state.data.push(data)
    },
    setFicha(state, {id, entidad, title}) {
        let indexExist = state.data.findIndex(f => f.id == id && f.entidad == entidad)
        if (!!~indexExist) {
            Vue.set(state.data[indexExist], 'title', title)
        }
    },
    delFicha (state, id) {
        let fichaIndex = state.data.findIndex(f => f.id == id)
        state.data.splice(fichaIndex, 1)
    },
    setFichaVisibleSection (state, {id, section}) {
        const ficha = state.data.find(f => f.id == id)
        ficha.section[section].open = !ficha.section[section].open
    },
    setSectionData(state, {id, section, data}) {
        const ficha = state.data.find(f => f.id == id)
        ficha.section[section] = data
    },
    setUpdateFicha(state, id) {
        
        //console.log('setUpdateFicha true')
        let indexExist = state.data.findIndex(f => f.id == id)

        if (!!~indexExist)  Vue.set(state.data[indexExist], 'update', true)
    },
    setUpdateFichaFalse(state, id) {
        //console.log('setUpdateFicha false')
        let indexExist = state.data.findIndex(f => f.id == id)

        if (!!~indexExist)  Vue.set(state.data[indexExist], 'update', false)
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}